
<button  mat-raised-button  class="btn-health" [class.btnpressed]="activeBtn==1">
  <p>{{label}}</p>
</button>
